import styled, { css } from 'styled-components';
import { SectionProps } from './SectionBanner';

export const Section = styled.section<Pick<SectionProps, 'bg' | 'bgFixed' | 'asideTop'>>`
	background: url(${({ bg }) => bg}) center #262524;
	padding: 100px 30px 60px 30px;
	color: #fff;

	${({ bgFixed }) =>
		bgFixed &&
		css`
			background-size: cover;
			background-repeat: no-repeat;
			background-attachment: fixed;

			@media (max-width: 768px) {
				background-attachment: unset;
			}
		`}

	${({ asideTop }) =>
		asideTop &&
		css`
			${SectionAside} {
				top: 25%;
				@media (min-width: 768px) {
					transform: rotate(-20deg);
				}

				& > div {
					scale: 1 -1;
				}
			}
		`}
`;

export const SectionHolder = styled.div`
	display: flex;
	align-items: center;
	width: 70vw;
	max-width: 1000px;
	min-width: 768px;
	padding: 0 0 0 150px;
	margin: 0 auto;
	position: relative;

	@media (max-width: 768px) {
		display: block;
		width: unset;
		min-width: unset;
		padding: 0;
	}
`;

export const SectionImage = styled.img`
	display: block;
	height: 600px;

	@media (max-width: 768px) {
		width: 80%;
		height: unset;
		margin: 0 auto;
	}
`;

export const SectionContent = styled.div`
	flex: 1;
	margin: 0 0 0 40px;

	h2 {
		text-transform: uppercase;
		font-size: 2.4rem;
		text-align: center;
	}

	p {
		margin: 24px 0 0;
		text-align: center;
		font-size: 1.3rem;
		padding: 0 0 32px;
	}

	@media (max-width: 768px) {
		margin: 20px 0 0;
		padding: 0 16px;

		h2 {
			position: absolute;
			top: -90px;
			left: 0;
			width: 100%;
			font-size: 2rem;
		}

		p {
			font-size: 1.1rem;
			padding: 0;
		}
	}
`;

export const SectionAside = styled.div`
	aside {
		font-family: 'jenna-sue', sans-serif;
		font-size: 2.4rem;
		max-width: 160px;
		text-align: center;
	}

	& > div {
		width: 69px;
		height: 80px;
		margin: 8px auto 0;
	}

	@media (min-width: 768px) {
		position: absolute;
		top: 60%;
		left: 0px;
		transform: rotate(20deg);
	}

	@media (max-width: 768px) {
		aside {
			max-width: unset;
			font-size: 2.2rem;
		}

		& > div {
			display: none;
		}
	}
`;

export const SectionDottedLine = styled.div`
	@media (max-width: 768px) {
		display: none;
	}
`;
